import {
  RouteStatus, GeneralStatus, ActivityStatus, TrainingStatus, FreightStatus,
} from 'enums/status';

export const statusType = {
  [GeneralStatus.Active]: {
    color: 'system.ongoing.default',
    bg: 'system.ongoing.transparent',
    label: GeneralStatus.Active.toLocaleUpperCase(),
  },
  [GeneralStatus.Invited]: {
    color: 'system.warn.default',
    bg: 'system.warn.transparent',
    label: GeneralStatus.Invited.toLocaleUpperCase(),
  },
  [GeneralStatus.Inactive]: {
    color: 'gray.400',
    bg: 'transparent',
    label: GeneralStatus.Inactive.toLocaleUpperCase(),
    border: '1px solid',
    borderColor: 'gray.400',
  },
  [RouteStatus.Finished]: {
    color: 'system.success.default',
    bg: 'system.success.transparent',
    label: 'FINALIZADA',
  },
  [RouteStatus.Scheduled]: {
    color: 'gray.500',
    bg: 'gray.transparent',
    label: 'PROGRAMADA',
  },
  [RouteStatus.Pending]: {
    color: 'system.warn.default',
    bg: 'system.warn.transparent',
    label: 'PENDENTE',
  },
  [RouteStatus.Alert]: {
    color: 'system.warn.default',
    bg: 'system.warn.transparent',
    label: 'ALERTA',
  },
  [RouteStatus.Overdue]: {
    color: 'system.error.default',
    bg: 'system.error.transparent',
    label: 'ATRASADA',
  },
  [RouteStatus.FinishedInOverdue]: {
    color: 'system.success.default',
    bg: 'system.error.transparent',
    label: 'FINALIZADA',
  },
  [RouteStatus.Ongoing]: {
    color: 'system.ongoing.default',
    bg: 'system.ongoing.transparent',
    label: 'EM ANDAMENTO',
  },
  [ActivityStatus.OngoingDispatch]: {
    color: 'system.ongoing.default',
    bg: 'system.ongoing.transparent',
    label: ActivityStatus.OngoingDispatch.toLocaleUpperCase(),
  },
  [ActivityStatus.OngoingTranshipment]: {
    color: 'system.ongoing.default',
    bg: 'system.ongoing.transparent',
    label: ActivityStatus.OngoingTranshipment.toLocaleUpperCase(),
  },
  [TrainingStatus.Finished]: {
    color: 'system.success.default',
    bg: 'system.success.transparent',
    label: TrainingStatus.Finished.toLocaleUpperCase(),
  },
  [TrainingStatus.Ongoing]: {
    color: 'system.ongoing.default',
    bg: 'system.ongoing.transparent',
    label: TrainingStatus.Ongoing.toLocaleUpperCase(),
  },
  [TrainingStatus.Pending]: {
    color: 'system.warn.default',
    bg: 'system.warn.transparent',
    label: TrainingStatus.Pending.toLocaleUpperCase(),
  },
  [TrainingStatus.InReview]: {
    color: 'system.warn.default',
    bg: 'system.warn.transparent',
    label: TrainingStatus.InReview.toLocaleUpperCase(),
  },
  [FreightStatus.Collected]: {
    color: 'system.ongoing.default',
    bg: 'system.ongoing.transparent',
    label: FreightStatus.Collected.toLocaleUpperCase(),
  },
  [FreightStatus.Delivered]: {
    color: 'system.success.default',
    bg: 'system.success.transparent',
    label: FreightStatus.Delivered.toLocaleUpperCase(),
  },
  [FreightStatus.Transhipment]: {
    color: 'system.ongoing.default',
    bg: 'system.ongoing.transparent',
    label: FreightStatus.Transhipment.toLocaleUpperCase(),
  },
  [FreightStatus.Dispatch]: {
    color: 'system.ongoing.default',
    bg: 'system.ongoing.transparent',
    label: FreightStatus.Dispatch.toLocaleUpperCase(),
  },
  [FreightStatus.Unproductive]: {
    color: 'system.warn.default',
    bg: 'system.warn.transparent',
    label: FreightStatus.Unproductive.toLocaleUpperCase(),
  },
};
